// 初期表示
export const PAGE_INIT = "corp/overseas/valuation/PAGE_INIT";
// 決算区分選択変更時
export const ACC_TYPE_CHANGE = "corp/overseas/valuation/ACC_TYPE_CHANGE";
// 表示条件変更時
export const CONDITION_CHANGE = "corp/overseas/valuation/CONDITION_CHANGE";
// 表示条件設定
export const CONDITION_SET = "corp/overseas/valuation/CONDITION_SET";
